// Shared by the interactive homepage and its build-time HTML snapshot.
export const WORKFLOW_STEPS = [1, 2, 3];
export const HOME_FAQS = ['browser', 'records', 'language', 'review', 'trial'];

export function homeStructuredData(t, locale, url) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebApplication',
        '@id': `${url}#application`,
        name: 'Noteician',
        url,
        description: t('seo.home'),
        applicationCategory: 'HealthApplication',
        operatingSystem: 'Web browser',
        inLanguage: locale,
      },
      {
        '@type': 'FAQPage',
        '@id': `${url}#questions`,
        inLanguage: locale,
        mainEntity: HOME_FAQS.map(id => ({
          '@type': 'Question',
          name: t(`home.faq.${id}.question`),
          acceptedAnswer: {
            '@type': 'Answer',
            text: t(`home.faq.${id}.answer`),
          },
        })),
      },
    ],
  };
}

export const serializeStructuredData = data => JSON.stringify(data).replace(/</g, '\\u003c');
